import { render, staticRenderFns } from "./ZoomMessages.vue?vue&type=template&id=456ba480&scoped=true&"
import script from "./ZoomMessages.vue?vue&type=script&lang=js&"
export * from "./ZoomMessages.vue?vue&type=script&lang=js&"
import style0 from "./ZoomMessages.vue?vue&type=style&index=0&id=456ba480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ba480",
  null
  
)

export default component.exports